import vueModel from './myVue';

var mymap, clustersCentres, originalMarkers=[], centres, clicked = null, centresLayer, myModel, myPopup, vm;
var filterButton, selectedIcon;

// var json_data='http://localhost/centres_practiques.json';
var json_data='//mapscloud.udg.edu/practiques_medicina/data/centres_practiques.json';
$(document).ready(function(e){
  $.when(
      $.ajax( {
          url: json_data,
          dataType: "json"
      } )).then( function ( response ) {
          centres=response
          var start = new initMap()
      }).fail(function(error){
        console.error('S\'ha produït un error: ', error);
    });

  myPopup = M.Modal.init(document.getElementById('popup-modal'),{'onOpenEnd': scrollTop, 'onCloseEnd': unSelectIcon});

  // events for center llistes
  //SAFARI FOR MAC
  // var ua = navigator.userAgent;
  // var clickHandler = (ua.match(/iPad/i)) ? "touchstart" : "click";

  var clickHandler = 'ontouchend' in document ? 'touchend' : 'click';

});

var initMap = function()
{
  mymap = L.map('mapid',{
    'condensedAttributionControl':false,
    minZoom: 8,
    maxZoom: 16
  }).setView([42.014611, 2.482910], 10);

  addControlPlaceholders(mymap);

  var centres_list_panel = L.control({position:'filterwindowleft'});
  centres_list_panel.onAdd = function (mymap){
    this._div = L.DomUtil.create('div', '');

    //IOS Dragging
    $('div:not(button)').on("touchstart", function(e){
        e.stopPropagation();
    });

    $('div:not(button)').on("touchmove", function(e){
        e.stopPropagation();
    });

    //Map events handlers
    this._div.addEventListener('mouseover', function () {
        mymap.dragging.disable();
        mymap.touchZoom.disable();
        mymap.doubleClickZoom.disable();
        mymap.scrollWheelZoom.disable();
    });
    this._div.addEventListener('mouseout', function () {
        mymap.dragging.enable();
        mymap.touchZoom.enable();
        mymap.doubleClickZoom.enable();
        mymap.scrollWheelZoom.enable();
    });

    $(this._div).on('mousedown',function (e) {
      // e.preventDefault();
      // e.stopImmediatePropagation();
      // L.DomEvent.stopPropagation;

      centresLayer.clearLayers()
      clustersCentres.clearLayers()
      // console.log(($(e.target).hasClass('active')))
      if ($(e.target).hasClass('material-icons')){
          $(e.target).parent().removeClass('active');
          var selectedType = ''
          for (var a=0; a < originalMarkers.length; a++){
            centresLayer.addLayer(originalMarkers[a]);
          }
          clustersCentres.addLayers(centresLayer.getLayers());
          mymap.fitBounds(centresLayer.getBounds())
      }
      else{
        if ( $(e.target).hasClass('active') ){
          $(e.target).removeClass('active');
          var selectedType = ''
          for (var a=0; a < originalMarkers.length; a++){
            centresLayer.addLayer(originalMarkers[a]);
          }
          clustersCentres.addLayers(centresLayer.getLayers());
          mymap.fitBounds(centresLayer.getBounds())
        }
        else
        {
          $('a.collection-item').removeClass('active');
          $(e.target).addClass('active');
          // var selectedType = $(this).attr('value')
          var selectedType = $(e.target).attr('value')

          for (var a=0; a < originalMarkers.length; a++){
            if (originalMarkers[a].options.tipus==selectedType){
              centresLayer.addLayer(originalMarkers[a]);
            }
          }
          clustersCentres.addLayers(centresLayer.getLayers());
          mymap.fitBounds(centresLayer.getBounds())
        }
      }
      if (filterIsActive()){
        filterButton.state('on')
      }
      else{
        filterButton.state('off')
      }

      if(window.matchMedia("(max-width: 600px)").matches){
        hideCentresPanel()
      }
    })

    this._div.innerHTML = `
            <div class="collection">
                <div class="tipus_centres">Tipus de centres</div>

                <div class="list-type"><a href="#!" value="Centre d'Atenció Primària" class="collection-item"><div class="icon-cap"></div>Centre d'Atenció Primària <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
                <div class="list-type"><a href="#!" value="Centre d'Atenció Primària universitari" class="collection-item"><div class="icon-cap-universitari"></div>Centre d'Atenció Primària universitari <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
                <div class="list-type"><a href="#!" value="Centre de rehabilitació" class="collection-item"><div class="icon-centre-rehab"></div>Centre de rehabilitació <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
                <div class="list-type"><a href="#!" value="Centre sociosanitari" class="collection-item"><div class="icon-sociosanitari"></div>Centre sociosanitari <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
                <div class="list-type"><a href="#!" value="Hospital universitari" class="collection-item"><div class="icon-hospital-uni"></div>Hospital universitari <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
                <div class="list-type"><a href="#!" value="Hospital" class="collection-item"><div class="icon-hospital"></div>Hospital <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
                <div class="list-type"><a href="#!" value="Altres dispositius assistencials" class="collection-item"><div class="icon-altres"></div>Altres dispositius assistencials <i id="tanca-llista-popup" class="material-icons">cancel</i></a></div>
            </div>`
    return this._div;
  }

  // Creating an attribution
  var credits = 'Iniciativa: <a href="https://www.udg.edu/ca/fm" target="_blank">Facultat de Medicina</a> de la <a target="_blank" href="https://www.udg.edu">Universitat de Girona</a> | Desenvolupament <a target="_blank" href="https://www.udg.edu/sigte">SIGTE</a>-UdG | © <a target="_blank" href="https://www.osm.org">OpenStreetMap contributors</a> | © <a target="_blank" href="https://www.mapbox.com">Mapbox</a> | <a target="_blank" href="https://leafletjs.com/">Leaflet</a>';

  L.control.condensedAttribution({
    emblem: '<div class="emblem-wrap"><i class="fa fa-info-circle" style="color:#485cc7;" aria-hidden="true"></i></div>',
    prefix: credits
  }).addTo(mymap);

  L.tileLayer('https://api.mapbox.com/styles/v1/mapesbasesigte/ck6cay5y50t0l1iqpqsrjz5cs/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwZXNiYXNlc2lndGUiLCJhIjoiY2s2Y2F4YnB5MDk4ZjNvb21rcWEzMHZ4NCJ9.oVtnggRtmtUL7GBav8Kstg', {
    maxZoom: 18,
    tileSize: 512,
    zoomOffset: -1
  }).addTo(mymap);

  var refresh = L.control({position:'topleft'});
  var refreshButton = L.easyButton({
      id: 'refresh-button',
      position:'topleft',
      states: [
          {
            stateName: 'on',
            title: 'Inici',
            // icon: '<div><object id="svg_refresh" data="./css/img/refresh.svg" type="image/svg+xml"></object></div>',
            icon: '<div class="reload_map"></div>',
            onClick: function(control) {
              location.reload();
            }
          }
        ]
    })

  // filter button and Panells
  filterButton = L.easyButton({
      id: 'filter-button',
      position:'topleft',
      states: [
          {
            stateName: 'off',
            title: 'Filtre',
            icon: '<div class="filter_map"></div>',
            // icon: '<div><object id="svg_inactive" data="./css/img/filter.svg" type="image/svg+xml"></object></div>',
            onClick: function(control) {
              toggleCentresPanel()
            }
          },
          {
            stateName: 'on',
            title: 'Filtre',
            icon: '<div class="filter_map_active"></div>',
            onClick: function(control) {
              ifMobileEnableMap()
              if (clicked!==null){
                unSelectIcon()
              }
              toggleCentresPanel()

              // if (filterIsActive()){
              //   showCentresPanel()
              // }
              // else{
              //   filterButton.state('off')
              //   hideCentresPanel()
              // }
            }
      }
        ]
    })



  centres_list_panel.addTo(mymap)
  refreshButton.addTo(mymap)

  mymap.addControl(new L.Control.Fullscreen({
      title: {
          'false': 'Pantalla completa',
          'true': 'Sortir pantalla completa'
      }
  }));

  filterButton.addTo(mymap)

  // CLUSTERS
  clustersCentres = L.markerClusterGroup({
      showCoverageOnHover: false,
      animateAddingMarkers: true,
      zoomToBoundsOnClick: true,
      //disableClusteringAtZoom: 16,
      maxClusterRadius: 40,

      iconCreateFunction: function(cluster) {
        var markersCluster = cluster.getAllChildMarkers();
        var numCentres = 0;

        markersCluster.forEach(function(entry) {
            numCentres += 1
        });

        var icon = radiusSize(numCentres);
        return icon;
      }
    });

    centresLayer = L.featureGroup();
    function newIcon(o){
      var iconClass=''
      switch (options.tipus) {
        case 'Centre d\'Atenció Primària':
          iconClass='cap'
          break;
        case 'Centre d\'Atenció Primària universitari':
          iconClass='cap-universitari'
          break;
        case 'Centre de rehabilitació':
          iconClass='centre-rehab'
          break;
        case 'Centre sociosanitari':
          iconClass='sociosanitari'
          break;
        case 'Hospital':
          iconClass='hospital'
          break;
        case 'Hospital universitari':
          iconClass='hospital-uni'
          break;
        case 'Altres dispositius assistencials':
          iconClass='altres'
          break;
        default:
          iconClass='icon-centres';
      }

      var icon = new L.DivIcon({
        html: '<div class="'+iconClass+'" tabindex="0"><div> </div></div>',
        iconSize: [32, 44],
        iconAnchor:[14,44]
      });
      return icon
    }


    // ITERATE FEATURES TO CREATE MARKERS
    //creem tots els marcadors i els posem dins del grup activitatsLayer
    for (var a=0; a < centres.features.length; a++){
      var f = centres.features[a]

      var options = f.properties
      if(f.geometry===null) continue;
      options.icon = newIcon(options)
      var m_location = [f.geometry.coordinates[1],f.geometry.coordinates[0] ]
      var m = L.marker(m_location, options)

      originalMarkers.push(m)
      centresLayer.addLayer(m)

      m.bindTooltip(wrapText(options.nom,4),{className: 'tooltipClass',direction:'right',offset:L.point({x: 10, y: 0})}).openTooltip()
      m.on('click', function(e){
          var _this = this
          setSelectedIcon(this);
          selectedIcon = this;
          // myModel.makeActive(this.options)
          mymap.setView(e.latlng, mymap.getZoom(), { animation: true });
          vm.makeActive(this.options)
          console.log('show modal popup')
          myPopup.open();
          // if ($(window).width() > minSizeToCenterPopup ){
          //   var newCenter = getNewCenterFromMarker(this)
          //   var newLatLon = mymap.containerPointToLatLng(newCenter);
          //   mymap.panTo(newLatLon);
          // }

      });
   }

    clustersCentres.addLayers(centresLayer.getLayers());
    mymap.addLayer(clustersCentres);
    mymap.fitBounds(centresLayer.getBounds())

    vm = new vueModel()
    // myModel = new viewModel()
    // ko.applyBindings(myModel);

    mymap.on('click',function(e){
      if ( isMobile() && centresPanelIsVisible() ){
        toggleCentresPanel()
      }
    })
}

function setSelectedIcon(marker){
  var numActivities = marker.options.participants
  var iconClass=''
  switch (marker.options.tipus) {
    case 'Centre d\'Atenció Primària':
      iconClass='cap-selected'
      break;
    case 'Centre d\'Atenció Primària universitari':
      iconClass='cap-universitari-selected'
      break;
    case 'Centre de rehabilitació':
      iconClass='centre-rehab-selected'
      break;
    case 'Centre sociosanitari':
      iconClass='sociosanitari-selected'
      break;
    case 'Hospital':
      iconClass='hospital-selected'
      break;
    case 'Hospital universitari':
      iconClass='hospital-uni-selected'
      break;
    case 'Altres dispositius assistencials':
      iconClass='altres-selected'
      break;
    default:
      iconClass='icon-centres-selected';
  }
  var iconSelected = new L.DivIcon({
    // html: '<div class=" icon-cooperacio-selected" tabindex="0"><div>'+numActivities.toString()+'</div></div>',
    html: '<div class="' + iconClass + '" tabindex="0"><div></div></div>',
    iconSize: [32, 44],
    iconAnchor:[14,44]
  });

  if(clicked != null){
    unSelectIcon()
  }
  clicked = marker;
  setTimeout(function(){clicked.fire('mouseout')}, 100)
  marker.setIcon(iconSelected);
}

function radiusSize(value){
  var ndigits = value.toString().length
  var size = 30 + (ndigits *10)
  var paddingTopClass = 'paddingTopClass-'+size;
  return new L.divIcon({
    className: 'mycluster', html:'<div class="textCluster '+paddingTopClass+'">'+value.toString()+'</div>', iconSize: L.point(size, size)
  });
}

function wrapText(text, num){
    var nou_text = '';
    var comptador = 0;
    var array_text = text.split(" ");

    for(var i=0; i<array_text.length; i++){
      if(comptador < num){
        nou_text += array_text[i];
        nou_text += " ";
        comptador++;
      }else{
        nou_text += "</br>";
        nou_text += array_text[i];
        nou_text += " ";
        comptador = 0;
      }
    }
    return nou_text;
}

function unSelectIcon(){
  var numActivities = clicked.options.length-1;
  var iconClass=''
  switch (selectedIcon.options.tipus) {
    case 'Centre d\'Atenció Primària':
      iconClass='cap'
      break;
    case 'Centre d\'Atenció Primària universitari':
      iconClass='cap-universitari'
      break;
    case 'Centre de rehabilitació':
      iconClass='centre-rehab'
      break;
    case 'Centre sociosanitari':
      iconClass='sociosanitari'
      break;
    case 'Hospital':
      iconClass='hospital'
      break;
    case 'Hospital universitari':
      iconClass='hospital-uni'
      break;
    case 'Altres dispositius assistencials':
      iconClass='altres'
      break;
    default:
      iconClass='icon-centres';
  }
  var icon = new L.DivIcon({
    html: '<div class="' + iconClass + '" tabindex="0"><div></div></div>',
    iconSize: [32, 44],
    iconAnchor:[14,44]
  });

  clicked.setIcon(icon);
}

function scrollTop(e){
    $(e).scrollTop(0);
}

function addControlPlaceholders(map) {
  var corners = map._controlCorners,
  l = 'leaflet-',
  container = map._controlContainer;

  function createCorner(vSide, hSide) {
    var className = l + vSide + ' ' + l + hSide;
    corners[vSide + hSide] = L.DomUtil.create('div', className, container);
  }

  createCorner('filterwindow', 'left');
}

function ifMobileEnableMap(){
  if (L.Browser.mobile){
    mymap.dragging.enable();
    mymap.touchZoom.enable();
    mymap.doubleClickZoom.enable();
    mymap.scrollWheelZoom.enable();
  }
}

function toggleCentresPanel(){
  if (centresPanelIsVisible()){
    hideCentresPanel()
  }
  else{
    showCentresPanel()
  }
}

function showCentresPanel(){
  if (isMobile()){
    // $('.leaflet-filterwindow').show();
    $('.leaflet-filterwindow').effect('slide', { direction: 'left', mode: 'show' }, 500);
  }
  else{
    $('.collection').fadeIn( "slow" );
  }
}

function hideCentresPanel(){
  if (isMobile()){
    $('.leaflet-filterwindow').effect('slide', { direction: 'left', mode: 'hide' }, 500);
    // $('.leaflet-filterwindow').hide();
  }
  else{
    $('.collection').fadeOut( "slow" );
  }
  ifMobileEnableMap()
}

function filterIsActive(){
  return ($('.collection-item.active').length>0)
}

function isMobile(){
  return (L.Browser.mobile);
  // return (window.matchMedia("(max-width: 600px)").matches);
}

function centresPanelIsVisible(){
  return $('.collection').is(":visible");

}
